module.exports = __webpack_public_path__ + "img/imagem-planta-palmeiras03.451f1eca.png";